import './LoadingSpinner.css';

interface ILoadingSpinnerProps {
  text?: string;
  size?: 'small' | 'medium' | 'large' | 'full';
}

const LoadingSpinner = ({ text = 'Carregando...', size = 'medium' }: ILoadingSpinnerProps) => {
  return (
    <div className={`loading-container loading-${size}`}>
      <div className="loading-spinner"></div>
      {text ? <div className="loading-text">{text}</div> : null}
    </div>
  );
};

export default LoadingSpinner;
